import MenuLabel from "./MenuLabel";
export default MenuLabel;